export enum SaveMode {
    Default,
    SaveAsPdf
  }